// src/utils/formatters.ts - Formatting utilities
export class FormattersService {
  public static formatDate(
    dateString: string,
    options?: Intl.DateTimeFormatOptions
  ): string {
    if (!dateString) return "-";

    try {
      const defaultOptions: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };

      const formatOptions = { ...defaultOptions, ...options };
      return new Date(dateString).toLocaleString("id-ID", formatOptions);
    } catch (error) {
      console.warn("Error formatting date:", error);
      return "-";
    }
  }

  public static formatRelativeTime(dateString: string): string {
    if (!dateString) return "-";

    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffMins < 1) return "Baru saja";
      if (diffMins < 60) return `${diffMins} menit lalu`;
      if (diffHours < 24) return `${diffHours} jam lalu`;
      if (diffDays < 7) return `${diffDays} hari lalu`;

      return this.formatDate(dateString);
    } catch (error) {
      console.warn("Error formatting relative time:", error);
      return "-";
    }
  }

  public static maskText(
    text: string,
    visibleStart: number = 4,
    visibleEnd: number = 4
  ): string {
    if (!text) return "-";
    if (text.length <= visibleStart + visibleEnd) return text;

    return (
      text.substring(0, visibleStart) +
      "..." +
      text.substring(text.length - visibleEnd)
    );
  }

  public static formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  public static formatNumber(num: number, locale: string = "id-ID"): string {
    return new Intl.NumberFormat(locale).format(num);
  }
}
